import { Alert, Platform } from 'react-native';
import _ from 'lodash';

export default class AlertUtils {

  /**
   * show alert
   *
   * @param title title of alert
   * @param message message of alert
   * @param actions actions of confirm dialog
   * @return for web only, true or false
   */
  static confirm = ({
                      title = global.__APP_NAME__,
                      message,
                      actions,
                    }) => {
    if (Platform.OS === 'web') {
      return window.confirm(message);
    } else {
      Alert.alert(
        title,
        message,
        actions,
      );
    }
    return false;
  };

  /**
   * show alert
   *
   * @param title title of alert
   * @param message message of alert
   * @param buttonText button text to show in alert
   * @param actions custom actions in mobile
   */
  static alert = ({
                    title = global.__APP_NAME__,
                    message,
                    buttonText = 'OK',
                    actions,
                    options,
                  }) => {
    if (Platform.OS === 'web') {
      window.alert(message);
    } else {
      Alert.alert(
        title,
        message,
        (_.isEmpty(actions)
          ? [
            {text: buttonText, style: 'cancel'},
          ]
          : actions),
        options,
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/AlertUtils.js